import React from 'react';

export const sendInterval = (
  count: number,
  setTimer: (time: number) => void,
  onTimeout: () => void,
) => {
  setTimer(count);
  let countValue = count;

  const timer = setInterval(() => {
    if (countValue > 0) {
      countValue = countValue - 1;
      setTimer(countValue);
    } else {
      clearInterval(timer);
      onTimeout();
    }
  }, 1000);

  return timer;
};

interface TimerProps {
  countdown: number;
}

export const TimerComponent: React.FC<TimerProps> = ({ countdown }) => {
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  return (
    <div className="timer">
      <p>{formatTime(countdown)}</p>
    </div>
  );
};
